import { useCopyFeedback } from "../../hooks/useCopyFeedback";
import { Icon } from "./Icon";

interface CopyFieldProps {
  readonly label: string;
  readonly value: string;
  readonly sensitive?: boolean;
}

/** Read-only configuration field with explicit, transient copy confirmation. */
export function CopyField({ label, value, sensitive = false }: CopyFieldProps) {
  const { copied, copy } = useCopyFeedback(value);

  return (
    <div className={`copy-field ${sensitive ? "copy-field-sensitive" : ""}`.trim()}>
      <span>{label}</span>
      <div>
        <code title={value}>{value}</code>
        <button
          aria-label={`复制${label}`}
          className="copy-button"
          type="button"
          onClick={() => { void copy(); }}
        >
          <Icon name={copied ? "check" : "copy"} size={14} />
          <span>{copied ? "已复制" : "复制"}</span>
        </button>
      </div>
    </div>
  );
}
